import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import { BillingPlanCardProps } from './use-billing-plans';
import styles from './BillingPlans.module.css';
import { Divider } from 'antd';
import { FacebookPartnerBadge, MetaBadge, AgencyPartnerBadge } from '@mm/icons';

export const PlanDescription = ({
  option,
  className,
  isAgency,
}: {
  option: BillingPlanCardProps;
  className?: string;
  isAgency?: boolean;
}) => {
  const metaBadges =
    option.category === 'meta' ||
    option.category === 'metaEmail' ||
    option.category === 'introductory';

  return (
    <div className={classNames(styles.points, className)}>
      <div
        className={classNames(styles.badges, {
          [styles.agencyBadge]: isAgency,
        })}
      >
        {metaBadges && <MetaBadge />}
        {metaBadges && <FacebookPartnerBadge />}
        {isAgency && <AgencyPartnerBadge />}
      </div>

      <div className={styles.pointsTitle}>What You Get</div>
      {option.pointsTitle && (
        <div className={styles.pointsTitle}>{option.pointsTitle}</div>
      )}
      {option.points?.map((point, idx) => (
        <div key={uniqueId(point)}>
          <div
            className={classNames(styles.pointContainer, styles.mainPoint)}
            key={uniqueId(point)}
          >
            {option.pointsIcons?.[idx] ? (
              <img src={option.pointsIcons?.[idx]} />
            ) : (
              <CheckOutlined className={styles.checkIcon} />
            )}
            {point}
          </div>
          {isAgency && option.costs?.[idx] && (
            <div className={styles.agencyCostItem}>{option.costs?.[idx]}</div>
          )}
          {isAgency && idx === 0 && <Divider className={styles.divider} />}
        </div>
      ))}
      {option.secondaryPoints?.map(point => (
        <div
          className={styles.pointContainer}
          key={uniqueId(typeof point === 'string' ? point : '')}
        >
          {!option.isFreeTrial && (
            <CheckOutlined className={styles.checkIcon} />
          )}

          {point}
        </div>
      ))}
      <div className={classNames(styles.points, styles.pricing)}>
        <div className={styles.pointsTitle}>Pricing</div>
        <div className={styles.pointContainer} style={{ fontWeight: 500 }}>
          {`${option.price}${option.pricePeriod} fixed monthly platform fee`}
        </div>
        {Array.isArray(option.costs) && option.costs?.length && (
          <div
            className={classNames(styles.priceTable, {
              [styles.agencyPriceTable]: isAgency,
            })}
          >
            {option.costs?.map(item => {
              const blueStyle = item.includes('custom pricing');
              return (
                <span
                  key={item}
                  className={classNames(styles.costItem, {
                    [styles.evenCostItems]:
                      ((Array.isArray(option.costs)
                        ? option.costs?.length
                        : undefined) || 0) %
                        2 ===
                      0,
                    [styles.blue]: blueStyle,
                  })}
                >
                  {item}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
